var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _polyline, _path157, _path158, _path159;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#020938;}.cls-2{fill:#00f78f;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{fill:url(#linear-gradient-13);}.cls-16{fill:url(#linear-gradient-14);}.cls-17{fill:url(#linear-gradient-15);}.cls-18{fill:url(#linear-gradient-16);}.cls-19{fill:url(#linear-gradient-17);}.cls-20{fill:url(#linear-gradient-18);}.cls-21{fill:url(#linear-gradient-19);}.cls-22{fill:url(#linear-gradient-20);}.cls-23{fill:url(#linear-gradient-21);}.cls-24{fill:url(#linear-gradient-22);}.cls-25{fill:url(#linear-gradient-23);}.cls-26{fill:url(#linear-gradient-24);}.cls-27{fill:url(#linear-gradient-25);}.cls-28{fill:url(#linear-gradient-26);}.cls-29{fill:url(#linear-gradient-27);}.cls-30{fill:url(#linear-gradient-28);}.cls-31{fill:url(#linear-gradient-29);}.cls-32{fill:url(#linear-gradient-30);}.cls-33{fill:url(#linear-gradient-31);}.cls-34{fill:url(#linear-gradient-32);}.cls-35{fill:url(#linear-gradient-33);}.cls-36{fill:url(#linear-gradient-34);}.cls-37{fill:url(#linear-gradient-35);}.cls-38{fill:url(#linear-gradient-36);}.cls-39{fill:url(#linear-gradient-37);}.cls-40{fill:url(#linear-gradient-38);}.cls-41{fill:url(#linear-gradient-39);}.cls-42{fill:url(#linear-gradient-40);}.cls-43{fill:url(#linear-gradient-41);}.cls-44{fill:url(#linear-gradient-42);}.cls-45{fill:url(#linear-gradient-43);}.cls-46{fill:url(#linear-gradient-44);}.cls-47{fill:url(#linear-gradient-45);}.cls-48{fill:url(#linear-gradient-46);}.cls-49{fill:url(#linear-gradient-47);}.cls-50{fill:url(#linear-gradient-48);}.cls-51{fill:url(#linear-gradient-49);}.cls-52{fill:url(#linear-gradient-50);}.cls-53{fill:url(#linear-gradient-51);}.cls-54{fill:url(#linear-gradient-52);}.cls-55{fill:url(#linear-gradient-53);}.cls-56{fill:url(#linear-gradient-54);}.cls-57{fill:url(#linear-gradient-55);}.cls-58{fill:url(#linear-gradient-56);}.cls-59{fill:url(#linear-gradient-57);}.cls-60{fill:url(#linear-gradient-58);}.cls-61{fill:url(#linear-gradient-59);}.cls-62{fill:url(#linear-gradient-60);}.cls-63{fill:url(#linear-gradient-61);}.cls-64{fill:url(#linear-gradient-62);}.cls-65{fill:url(#linear-gradient-63);}.cls-66{fill:url(#linear-gradient-64);}.cls-67{fill:url(#linear-gradient-65);}.cls-68{fill:url(#linear-gradient-66);}.cls-69{fill:url(#linear-gradient-67);}.cls-70{fill:url(#linear-gradient-68);}.cls-71{fill:url(#linear-gradient-69);}.cls-72{fill:url(#linear-gradient-70);}.cls-73{fill:url(#linear-gradient-71);}.cls-74{fill:url(#linear-gradient-72);}.cls-75{fill:url(#linear-gradient-73);}.cls-76{fill:url(#linear-gradient-74);}.cls-77{fill:url(#linear-gradient-75);}.cls-78{fill:url(#linear-gradient-76);}.cls-79{fill:url(#linear-gradient-77);}.cls-80{fill:url(#linear-gradient-78);}.cls-81{fill:url(#linear-gradient-79);}.cls-82{fill:url(#linear-gradient-80);}.cls-83{fill:url(#linear-gradient-81);}.cls-84{fill:url(#linear-gradient-82);}.cls-85{fill:url(#linear-gradient-83);}.cls-86{fill:url(#linear-gradient-84);}.cls-87{fill:url(#linear-gradient-85);}.cls-88{fill:url(#linear-gradient-86);}.cls-89{fill:url(#linear-gradient-87);}.cls-90{fill:url(#linear-gradient-88);}.cls-91{fill:url(#linear-gradient-89);}.cls-92{fill:url(#linear-gradient-90);}.cls-93{fill:url(#linear-gradient-91);}.cls-94{fill:url(#linear-gradient-92);}.cls-95{fill:url(#linear-gradient-93);}.cls-96{fill:url(#linear-gradient-94);}.cls-97{fill:url(#linear-gradient-95);}.cls-98{fill:url(#linear-gradient-96);}.cls-99{fill:url(#linear-gradient-97);}.cls-100{fill:url(#linear-gradient-98);}.cls-101{fill:url(#linear-gradient-99);}.cls-102{fill:url(#linear-gradient-100);}.cls-103{fill:url(#linear-gradient-101);}.cls-104{fill:url(#linear-gradient-102);}.cls-105{fill:url(#linear-gradient-103);}.cls-106{fill:url(#linear-gradient-104);}.cls-107{fill:url(#linear-gradient-105);}.cls-108{fill:url(#linear-gradient-106);}.cls-109{fill:url(#linear-gradient-107);}.cls-110{fill:url(#linear-gradient-108);}.cls-111{fill:url(#linear-gradient-109);}.cls-112{fill:url(#linear-gradient-110);}.cls-113{fill:url(#linear-gradient-111);}.cls-114{fill:url(#linear-gradient-112);}.cls-115{fill:url(#linear-gradient-113);}.cls-116{fill:url(#linear-gradient-114);}.cls-117{fill:url(#linear-gradient-115);}.cls-118{fill:url(#linear-gradient-116);}.cls-119{fill:url(#linear-gradient-117);}.cls-120{fill:url(#linear-gradient-118);}.cls-121{fill:url(#linear-gradient-119);}.cls-122{fill:url(#linear-gradient-120);}.cls-123{fill:url(#linear-gradient-121);}.cls-124{fill:url(#linear-gradient-122);}.cls-125{fill:url(#linear-gradient-123);}.cls-126{fill:url(#linear-gradient-124);}.cls-127{fill:url(#linear-gradient-125);}.cls-128{fill:url(#linear-gradient-126);}.cls-129{fill:url(#linear-gradient-127);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 458.24,
    y1: 474.08,
    x2: 469.68,
    y2: 474.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f78f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#04e6a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0fb9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13a6ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 449.09,
    y1: 469.7,
    x2: 462.01,
    y2: 469.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 439.8,
    y1: 467.95,
    x2: 453.83,
    y2: 467.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 430.83,
    y1: 469.5,
    x2: 445.62,
    y2: 469.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 422.66,
    y1: 474.78,
    x2: 437.87,
    y2: 474.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 415.61,
    y1: 483.63,
    x2: 430.95,
    y2: 483.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 409.8,
    y1: 495.45,
    x2: 425.08,
    y2: 495.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 405.3,
    y1: 509.84,
    x2: 420.39,
    y2: 509.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 402.09,
    y1: 526.26,
    x2: 416.93,
    y2: 526.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 400.07,
    y1: 544.02,
    x2: 414.67,
    y2: 544.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 399.07,
    y1: 562.31,
    x2: 413.53,
    y2: 562.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 398.87,
    y1: 580.23,
    x2: 413.45,
    y2: 580.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 399.04,
    y1: 596.39,
    x2: 413.61,
    y2: 596.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 399.19,
    y1: 609.5,
    x2: 413.53,
    y2: 609.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 398.71,
    y1: 619.1,
    x2: 413.05,
    y2: 619.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 397.43,
    y1: 625.03,
    x2: 411.91,
    y2: 625.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 395.15,
    y1: 627.3,
    x2: 409.86,
    y2: 627.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 448.17,
    y1: 465.91,
    x2: 460.78,
    y2: 465.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 437.73,
    y1: 461.94,
    x2: 451.64,
    y2: 461.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 427.34,
    y1: 460.74,
    x2: 442.19,
    y2: 460.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 417.43,
    y1: 463.14,
    x2: 432.89,
    y2: 463.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 408.46,
    y1: 469.4,
    x2: 424.21,
    y2: 469.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 400.8,
    y1: 479.36,
    x2: 416.57,
    y2: 479.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 394.54,
    y1: 492.19,
    x2: 410.16,
    y2: 492.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 389.7,
    y1: 507.54,
    x2: 405.05,
    y2: 507.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 386.2,
    y1: 524.75,
    x2: 401.26,
    y2: 524.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 383.89,
    y1: 543.06,
    x2: 398.71,
    y2: 543.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 382.77,
    y1: 561.6,
    x2: 397.26,
    y2: 561.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 382.62,
    y1: 579.44,
    x2: 396.73,
    y2: 579.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 383,
    y1: 595.44,
    x2: 397.04,
    y2: 595.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 383.49,
    y1: 608.29,
    x2: 397.13,
    y2: 608.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 383.34,
    y1: 617.48,
    x2: 396.94,
    y2: 617.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 382.3,
    y1: 623.04,
    x2: 396.06,
    y2: 623.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 380.28,
    y1: 624.86,
    x2: 394.26,
    y2: 624.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 438.85,
    y1: 460.28,
    x2: 451.04,
    y2: 460.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 425.86,
    y1: 456.35,
    x2: 440.53,
    y2: 456.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 414.47,
    y1: 455.61,
    x2: 429.89,
    y2: 455.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 403.73,
    y1: 458.54,
    x2: 419.58,
    y2: 458.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 394.07,
    y1: 465.59,
    x2: 410.04,
    y2: 465.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 385.86,
    y1: 476.2,
    x2: 401.72,
    y2: 476.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 379.21,
    y1: 489.83,
    x2: 394.79,
    y2: 489.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 374.07,
    y1: 505.86,
    x2: 389.3,
    y2: 505.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 370.47,
    y1: 523.53,
    x2: 385.2,
    y2: 523.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 368.37,
    y1: 541.96,
    x2: 382.38,
    y2: 541.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 367.52,
    y1: 560.22,
    x2: 380.78,
    y2: 560.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 367.47,
    y1: 577.45,
    x2: 380.41,
    y2: 577.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 367.96,
    y1: 592.8,
    x2: 381,
    y2: 592.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 368.71,
    y1: 605.1,
    x2: 381.37,
    y2: 605.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 368.89,
    y1: 613.82,
    x2: 381.34,
    y2: 613.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 368.06,
    y1: 618.61,
    x2: 380.69,
    y2: 618.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 366.37,
    y1: 619.79,
    x2: 379.13,
    y2: 619.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 415.26,
    y1: 453.41,
    x2: 429.09,
    y2: 453.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 401.68,
    y1: 452.97,
    x2: 417.41,
    y2: 452.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 390.28,
    y1: 456.32,
    x2: 406.23,
    y2: 456.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 380.07,
    y1: 463.65,
    x2: 395.97,
    y2: 463.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 371.43,
    y1: 474.79,
    x2: 387.03,
    y2: 474.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 364.58,
    y1: 488.95,
    x2: 379.67,
    y2: 488.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 359.65,
    y1: 505.28,
    x2: 373.86,
    y2: 505.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 356.43,
    y1: 522.89,
    x2: 369.62,
    y2: 522.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 354.67,
    y1: 540.91,
    x2: 366.97,
    y2: 540.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 354.07,
    y1: 558.46,
    x2: 365.67,
    y2: 558.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 354.13,
    y1: 574.75,
    x2: 365.56,
    y2: 574.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 354.72,
    y1: 589.03,
    x2: 366.28,
    y2: 589.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 355.6,
    y1: 600.64,
    x2: 366.91,
    y2: 600.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 356.07,
    y1: 608.3,
    x2: 367,
    y2: 608.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 355.45,
    y1: 612.2,
    x2: 366.57,
    y2: 612.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 354.39,
    y1: 612.74,
    x2: 365.24,
    y2: 612.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 389.72,
    y1: 453.1,
    x2: 404.96,
    y2: 453.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 377.28,
    y1: 456.72,
    x2: 393.08,
    y2: 456.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 366.81,
    y1: 464.25,
    x2: 382.26,
    y2: 464.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 358.26,
    y1: 475.6,
    x2: 372.86,
    y2: 475.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 351.8,
    y1: 489.85,
    x2: 365.23,
    y2: 489.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 347.29,
    y1: 505.97,
    x2: 359.57,
    y2: 505.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 344.48,
    y1: 523.09,
    x2: 355.71,
    y2: 523.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 343.07,
    y1: 540.32,
    x2: 353.42,
    y2: 540.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 342.75,
    y1: 556.84,
    x2: 352.41,
    y2: 556.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 342.93,
    y1: 571.85,
    x2: 352.57,
    y2: 571.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 343.65,
    y1: 584.69,
    x2: 353.35,
    y2: 584.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 344.6,
    y1: 595.05,
    x2: 354.17,
    y2: 595.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 345.27,
    y1: 601.48,
    x2: 354.39,
    y2: 601.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 344.9,
    y1: 604.22,
    x2: 354.14,
    y2: 604.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 347.11,
    y1: 605.48,
    x2: 353.04,
    y2: 605.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 365.28,
    y1: 460.12,
    x2: 380.33,
    y2: 460.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 355.25,
    y1: 467.62,
    x2: 369.2,
    y2: 467.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 347.17,
    y1: 478.74,
    x2: 359.85,
    y2: 478.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 341.18,
    y1: 492.63,
    x2: 352.58,
    y2: 492.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 337.16,
    y1: 508.18,
    x2: 347.33,
    y2: 508.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 334.81,
    y1: 524.47,
    x2: 343.9,
    y2: 524.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 333.81,
    y1: 540.6,
    x2: 342,
    y2: 540.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 333.72,
    y1: 555.76,
    x2: 341.31,
    y2: 555.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 334.16,
    y1: 569.2,
    x2: 341.78,
    y2: 569.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 335.07,
    y1: 580.38,
    x2: 342.65,
    y2: 580.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 336.11,
    y1: 588.98,
    x2: 343.58,
    y2: 588.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 336.92,
    y1: 593.84,
    x2: 343.97,
    y2: 593.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 337.76,
    y1: 595.62,
    x2: 343.84,
    y2: 595.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 345.64,
    y1: 473.62,
    x2: 357.71,
    y2: 473.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 338.21,
    y1: 484.15,
    x2: 348.87,
    y2: 484.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 332.81,
    y1: 497.41,
    x2: 342.07,
    y2: 497.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 329.38,
    y1: 512.12,
    x2: 337.33,
    y2: 512.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 327.59,
    y1: 527.29,
    x2: 334.38,
    y2: 527.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 327.09,
    y1: 542.05,
    x2: 332.93,
    y2: 542.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 327.25,
    y1: 555.59,
    x2: 332.75,
    y2: 555.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 328.07,
    y1: 567.19,
    x2: 333.48,
    y2: 567.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 329.25,
    y1: 576.5,
    x2: 334.51,
    y2: 576.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 330.47,
    y1: 582.95,
    x2: 335.53,
    y2: 582.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 331.66,
    y1: 586.08,
    x2: 336.1,
    y2: 586.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 339.23,
    y1: 481.96,
    x2: 346.03,
    y2: 481.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 331.36,
    y1: 491.91,
    x2: 339.93,
    y2: 491.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 326.74,
    y1: 504.25,
    x2: 333.77,
    y2: 504.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 324.03,
    y1: 517.89,
    x2: 329.64,
    y2: 517.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 322.93,
    y1: 531.74,
    x2: 327.29,
    y2: 531.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 322.88,
    y1: 544.9,
    x2: 326.38,
    y2: 544.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 323.54,
    y1: 556.59,
    x2: 326.85,
    y2: 556.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 324.84,
    y1: 566.14,
    x2: 327.92,
    y2: 566.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 326.41,
    y1: 573.3,
    x2: 329.21,
    y2: 573.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 328.14,
    y1: 577.82,
    x2: 330.38,
    y2: 577.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 327.32,
    y1: 501.36,
    x2: 332.16,
    y2: 501.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 322.97,
    y1: 513.08,
    x2: 327.71,
    y2: 513.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 321.17,
    y1: 525.56,
    x2: 324.34,
    y2: 525.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 320.87,
    y1: 537.95,
    x2: 322.72,
    y2: 537.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 321.33,
    y1: 549.29,
    x2: 322.71,
    y2: 549.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 322.42,
    y1: 558.96,
    x2: 323.78,
    y2: 558.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 323.97,
    y1: 566.12,
    x2: 325.39,
    y2: 566.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 326.12,
    y1: 571.03,
    x2: 326.47,
    y2: 571.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 320.63,
    y1: 533.4,
    x2: 321.45,
    y2: 533.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 320.62,
    y1: 544.39,
    x2: 321.07,
    y2: 544.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 321.33,
    y1: 553.33,
    x2: 322.1,
    y2: 553.33,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.06,527.24V502.39h5.47v24.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M481.17,527.24l-12-15.8v15.8h-5.4V502.39h5l11.65,15.3v-15.3h5.39v24.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503,507.43v19.81h-5.47V507.43H490v-5H510.6v5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514.79,527.24V502.39H533.5v4.87H520.19v5H531.9v4.86H520.19v5.22h13.48v4.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.66,527.24l-5.32-8H544v8h-5.47V502.39h11.36a10.11,10.11,0,0,1,6.91,2.17,7.61,7.61,0,0,1,2.47,6v.07a7.81,7.81,0,0,1-1.48,4.92,8.46,8.46,0,0,1-3.85,2.79l6.07,8.87Zm.11-16.36a3.18,3.18,0,0,0-1.14-2.67,5,5,0,0,0-3.16-.88H544v7.13h5.54a4.51,4.51,0,0,0,3.1-1,3.22,3.22,0,0,0,1.09-2.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M581.67,527.24l-12-15.8v15.8h-5.4V502.39h5l11.64,15.3v-15.3h5.4v24.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.78,527.24l-2.27-5.57H598l-2.27,5.57h-5.58l10.65-25h5l10.65,25Zm-7.53-18.46-3.3,8.06h6.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.58,507.43v19.81h-5.47V507.43h-7.56v-5h20.59v5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M643.58,527.24V502.39h5.47v24.85Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.58,519.8a12.75,12.75,0,0,1-7,6.86,14.38,14.38,0,0,1-10.59,0,13.2,13.2,0,0,1-4.17-2.74,12.15,12.15,0,0,1-2.74-4,12.79,12.79,0,0,1-1-5v-.07a12.59,12.59,0,0,1,1-5,12.71,12.71,0,0,1,6.94-6.85,14.41,14.41,0,0,1,10.6,0,13,13,0,0,1,4.17,2.73,12.27,12.27,0,0,1,2.73,4.05,12.76,12.76,0,0,1,1,5v.07A12.58,12.58,0,0,1,679.58,519.8Zm-4.73-5a8.22,8.22,0,0,0-.55-3,7.29,7.29,0,0,0-1.56-2.49,7.38,7.38,0,0,0-2.39-1.68,7.22,7.22,0,0,0-3-.62,7.5,7.5,0,0,0-3,.6,6.9,6.9,0,0,0-2.34,1.67,7.9,7.9,0,0,0-1.53,2.47,8.24,8.24,0,0,0-.55,3v.07a8.38,8.38,0,0,0,.55,3,7.47,7.47,0,0,0,1.57,2.49,7.59,7.59,0,0,0,2.37,1.69,7.77,7.77,0,0,0,6.06,0,6.89,6.89,0,0,0,2.36-1.67,7.76,7.76,0,0,0,1.52-2.46,8.11,8.11,0,0,0,.55-3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M702.86,527.24l-12-15.8v15.8h-5.4V502.39h5l11.65,15.3v-15.3h5.39v24.85Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M732,527.24l-2.27-5.57H719.19l-2.27,5.57h-5.57l10.65-25h5l10.65,25Zm-7.52-18.46-3.31,8.06h6.61Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.52,527.24V502.39H747v19.92h12.39v4.93Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.83,569.11a15,15,0,0,1-6.05,1.16,14.18,14.18,0,0,1-5.31-1,12.34,12.34,0,0,1-4.12-2.66,12.09,12.09,0,0,1-2.68-4,13.36,13.36,0,0,1-1-5.11v-.07a12.76,12.76,0,0,1,3.7-9.07,12.57,12.57,0,0,1,4.11-2.77,13.13,13.13,0,0,1,5.22-1,17.74,17.74,0,0,1,3,.23,14.74,14.74,0,0,1,2.54.65,12.1,12.1,0,0,1,2.2,1.07,15.91,15.91,0,0,1,2,1.45l-3.44,4.16a13.2,13.2,0,0,0-1.42-1.07,8.64,8.64,0,0,0-1.47-.78,9.08,9.08,0,0,0-1.65-.5,10.76,10.76,0,0,0-2-.17,6.25,6.25,0,0,0-2.78.62,7.34,7.34,0,0,0-2.27,1.67,7.57,7.57,0,0,0-1.53,2.46,8.08,8.08,0,0,0-.55,3v.07a8.69,8.69,0,0,0,.55,3.15,7.6,7.6,0,0,0,1.56,2.51,7.35,7.35,0,0,0,2.38,1.66,7.61,7.61,0,0,0,3,.58,8.59,8.59,0,0,0,5.15-1.5v-3.57h-5.5v-4.73h10.79v10.8A18.25,18.25,0,0,1,469.83,569.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504,562.4a13,13,0,0,1-2.75,4.09,12.74,12.74,0,0,1-4.19,2.76,14.25,14.25,0,0,1-10.59,0,13.16,13.16,0,0,1-4.18-2.73,12.27,12.27,0,0,1-2.73-4,12.74,12.74,0,0,1-1-5v-.07a12.59,12.59,0,0,1,1-5,12.82,12.82,0,0,1,2.75-4.08,12.61,12.61,0,0,1,4.19-2.77,14.41,14.41,0,0,1,10.6,0,13.11,13.11,0,0,1,4.17,2.73,12.27,12.27,0,0,1,2.73,4.05,12.76,12.76,0,0,1,1,5v.07A12.58,12.58,0,0,1,504,562.4Zm-4.72-5a8.22,8.22,0,0,0-.55-3,7.61,7.61,0,0,0-1.56-2.49,7.42,7.42,0,0,0-2.4-1.68,7.18,7.18,0,0,0-3-.62,7.46,7.46,0,0,0-3,.6,6.9,6.9,0,0,0-2.34,1.67,7.9,7.9,0,0,0-1.53,2.47,8,8,0,0,0-.55,3v.07a8.17,8.17,0,0,0,.55,3,7.43,7.43,0,0,0,3.94,4.17,7.16,7.16,0,0,0,3,.63,7.5,7.5,0,0,0,3-.61,6.79,6.79,0,0,0,2.36-1.67,7.79,7.79,0,0,0,1.53-2.46,8.11,8.11,0,0,0,.55-3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.56,570h-4.82l-10.05-25h6l6.5,17.5,6.5-17.5h5.89Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.44,569.84V545h18.71v4.86H541.84v5h11.71v4.86H541.84V565h13.49v4.86Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.32,569.84l-5.33-8H565.7v8h-5.47V545h11.36a10.07,10.07,0,0,1,6.9,2.17,7.58,7.58,0,0,1,2.47,6v.07a7.82,7.82,0,0,1-1.47,4.92,8.64,8.64,0,0,1-3.85,2.79l6.07,8.87Zm.1-16.36a3.19,3.19,0,0,0-1.13-2.67,5,5,0,0,0-3.16-.88H565.7v7.13h5.53a4.54,4.54,0,0,0,3.11-1,3.24,3.24,0,0,0,1.08-2.55Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.32,569.84l-12-15.8v15.8h-5.4V545h5l11.65,15.3V545H608v24.85Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.43,569.84l-2.27-5.57H619.65l-2.27,5.57h-5.57l10.65-25h5l10.65,25Zm-7.52-18.46-3.3,8.06h6.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M659.41,569.84l-12-15.8v15.8H642V545h5l11.65,15.3V545h5.39v24.85Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.87,567.68a12.31,12.31,0,0,1-2.25,1.4,11.7,11.7,0,0,1-2.68.88,15.53,15.53,0,0,1-3.27.31,13,13,0,0,1-5.08-1,12.27,12.27,0,0,1-6.71-6.78,13.24,13.24,0,0,1-1-5v-.07a13.12,13.12,0,0,1,1-5,12.77,12.77,0,0,1,2.67-4.08,12,12,0,0,1,4.08-2.77,13.18,13.18,0,0,1,5.25-1,16.43,16.43,0,0,1,3.18.28,13.34,13.34,0,0,1,2.61.78,10.82,10.82,0,0,1,2.16,1.21,13.88,13.88,0,0,1,1.85,1.56l-3.48,4a13.22,13.22,0,0,0-3-2.06,7.53,7.53,0,0,0-3.39-.74,7,7,0,0,0-2.9.6,6.91,6.91,0,0,0-2.29,1.67,8,8,0,0,0-1.49,2.47,8.45,8.45,0,0,0-.53,3v.07a8.59,8.59,0,0,0,.53,3,8,8,0,0,0,1.48,2.49,6.89,6.89,0,0,0,5.2,2.31,7.6,7.6,0,0,0,3.6-.78,14.75,14.75,0,0,0,2.93-2.13l3.48,3.51A18,18,0,0,1,689.87,567.68Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.22,569.84V545h18.71v4.86H701.62v5h11.71v4.86H701.62V565h13.49v4.86Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.74,608a9.53,9.53,0,0,1-3.15-1.92,9.23,9.23,0,0,1-2.14-3,10,10,0,0,1-.78-4,14.05,14.05,0,0,1,1.1-5.46,15.49,15.49,0,0,1,3-4.64,14.76,14.76,0,0,1,4.46-3.22,12.65,12.65,0,0,1,5.45-1.2,9.81,9.81,0,0,1,5.44,1.42,9.64,9.64,0,0,1,3.37,3.59l-2.27,1.4a8.84,8.84,0,0,0-2.63-2.91,7.26,7.26,0,0,0-4.14-1.06,9.38,9.38,0,0,0-4.27,1,11.72,11.72,0,0,0-3.5,2.67,12.45,12.45,0,0,0-2.37,3.83,12,12,0,0,0-.87,4.48,8,8,0,0,0,.55,3,6.69,6.69,0,0,0,1.52,2.3,6.3,6.3,0,0,0,2.3,1.45,8.18,8.18,0,0,0,2.94.5,8.84,8.84,0,0,0,4.05-.85A12.71,12.71,0,0,0,469,603l1.77,1.74a17.48,17.48,0,0,1-1.76,1.52,12.15,12.15,0,0,1-2.06,1.25,11.48,11.48,0,0,1-2.44.83,13,13,0,0,1-2.89.3A11.15,11.15,0,0,1,457.74,608Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.38,607.83a9.59,9.59,0,0,1-5.33-5.37,10.57,10.57,0,0,1-.75-4,13.58,13.58,0,0,1,1.05-5.24,14.72,14.72,0,0,1,2.87-4.49,14.05,14.05,0,0,1,4.3-3.13,12.36,12.36,0,0,1,5.39-1.19,10.55,10.55,0,0,1,4.15.79,9.61,9.61,0,0,1,5.34,5.35,10.39,10.39,0,0,1,.75,4,13.71,13.71,0,0,1-1,5.26,14.65,14.65,0,0,1-2.87,4.5,14.08,14.08,0,0,1-4.3,3.14,12.39,12.39,0,0,1-5.39,1.18A10.81,10.81,0,0,1,482.38,607.83Zm8.58-2.64a10.88,10.88,0,0,0,3.37-2.6,12.5,12.5,0,0,0,2.24-3.7,11.67,11.67,0,0,0,.81-4.26,8.65,8.65,0,0,0-.53-3.07,6.93,6.93,0,0,0-4-4.1,8.05,8.05,0,0,0-3.16-.6,9.38,9.38,0,0,0-4.25,1,11.19,11.19,0,0,0-3.37,2.6,12.55,12.55,0,0,0-2.24,3.71,11.67,11.67,0,0,0-.82,4.25,8.61,8.61,0,0,0,.54,3.09,7.11,7.11,0,0,0,1.53,2.45,7.3,7.3,0,0,0,2.41,1.64,8,8,0,0,0,3.17.6A9.26,9.26,0,0,0,491,605.19Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M508.73,584.82h2.44l9.51,18.95,5.1-18.95h2.57l-6.27,23.36H520l-9.75-19.39L505,608.18h-2.57Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535,584.82h16.78l-.63,2.44H536.93l-2.24,8.34h12.68l-.67,2.4H534.06l-2.74,10.18h-2.64Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.91,584.82h16.72l-.67,2.4H558.88l-2.13,8h12.58l-.67,2.4H556.11l-2.2,8.18h14.25l-.63,2.4H550.64Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M578.7,584.82h8.41a9.6,9.6,0,0,1,5.33,1.29,5.1,5.1,0,0,1,2.32,3.62,8.13,8.13,0,0,1-3.69,7.63,12.35,12.35,0,0,1-4.39,1.48l4.8,9.34h-3l-4.61-9.08H577.5l-2.43,9.08h-2.64Zm5.78,11.95a11,11,0,0,0,4.35-.76,5.17,5.17,0,0,0,2.55-2,4.72,4.72,0,0,0,.94-3.28,3.36,3.36,0,0,0-1.47-2.53,6.66,6.66,0,0,0-3.87-.92h-6.27l-2.57,9.51Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M602.63,584.82h16.72l-.67,2.4H604.6l-2.14,8H615l-.66,2.4H601.83l-2.2,8.18h14.25l-.64,2.4H596.36Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M624.42,584.82h2.44l9.51,18.95,5.1-18.95H644l-6.27,23.36h-2.1l-9.75-19.39-5.2,19.39h-2.57Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.28,608a9.53,9.53,0,0,1-3.15-1.92,9.23,9.23,0,0,1-2.14-3,10,10,0,0,1-.78-4,14.05,14.05,0,0,1,1.1-5.46,15.69,15.69,0,0,1,3-4.64,14.76,14.76,0,0,1,4.46-3.22,12.66,12.66,0,0,1,5.46-1.2,9.78,9.78,0,0,1,5.43,1.42,9.56,9.56,0,0,1,3.37,3.59l-2.26,1.4a9,9,0,0,0-2.64-2.91,7.26,7.26,0,0,0-4.14-1.06,9.38,9.38,0,0,0-4.27,1,11.85,11.85,0,0,0-3.5,2.67,12.84,12.84,0,0,0-2.37,3.83,12,12,0,0,0-.87,4.48,8,8,0,0,0,.55,3,6.69,6.69,0,0,0,1.52,2.3,6.3,6.3,0,0,0,2.3,1.45,8.18,8.18,0,0,0,2.94.5,8.84,8.84,0,0,0,4.05-.85,12.53,12.53,0,0,0,3.19-2.32l1.77,1.74a18.52,18.52,0,0,1-1.75,1.52,12.65,12.65,0,0,1-2.07,1.25,11.48,11.48,0,0,1-2.44.83,13,13,0,0,1-2.89.3A11.15,11.15,0,0,1,652.28,608Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.17,584.82h16.72l-.67,2.4H677.14l-2.13,8h12.58l-.67,2.4H674.37l-2.2,8.18h14.25l-.63,2.4H668.9Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.24,468.87c1.13.67,2.65,1.55,3.74,2.27,1.69,1.54,4,3.55,5.6,5.16.63.9,1.48,2.08,2.1,3-.95-.73-2.2-1.73-3.18-2.42-1.75-1.58-4-3.73-5.85-5.23-.72-.84-1.67-2-2.41-2.77"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.09,465.2c1.19.36,2.78.81,3.94,1.25,1.93,1.35,4.52,3.1,6.38,4.54.78,1,1.83,2.23,2.6,3.21-1-.45-2.4-1.09-3.46-1.48-1.95-1.34-4.53-3.17-6.54-4.42-.87-.93-2-2.18-2.92-3.1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M439.8,464.47c1.18,0,2.76-.15,3.95-.09,2.1,1.08,4.92,2.49,7,3.67.93,1,2.19,2.43,3.11,3.49-1.06-.07-2.47-.22-3.53-.21-2.11-1-4.9-2.44-7.06-3.37-1-1-2.4-2.46-3.44-3.49"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M430.83,467.31c1.12-.52,2.59-1.27,3.75-1.69,2.22.76,5.2,1.73,7.39,2.59,1.1,1.15,2.56,2.69,3.65,3.85-1,.39-2.41.86-3.39,1.33-2.22-.66-5.16-1.58-7.4-2.15l-4-3.93"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.66,473.88c1-1,2.3-2.31,3.36-3.22,2.29.4,5.36.88,7.64,1.37l4.21,4.11c-.93.82-2.2,1.88-3.07,2.76-2.27-.27-5.29-.68-7.57-.87l-4.57-4.15"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.61,483.79c.85-1.39,1.95-3.27,2.86-4.62,2.32,0,5.41,0,7.73.15l4.75,4.25c-.8,1.24-1.9,2.87-2.64,4.15-2.28.1-5.33.2-7.61.37l-5.09-4.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M409.8,496.68c.69-1.75,1.58-4.1,2.32-5.83,2.31-.32,5.4-.77,7.72-1,1.57,1.3,3.66,3,5.24,4.33-.65,1.62-1.55,3.76-2.15,5.4-2.27.45-5.3,1-7.56,1.52l-5.57-4.4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M405.3,512.06c.52-2,1.19-4.79,1.76-6.82,2.29-.62,5.33-1.47,7.63-2,1.71,1.31,4,3.06,5.7,4.35-.49,1.93-1.18,4.5-1.63,6.43-2.24.75-5.23,1.72-7.45,2.49l-6-4.41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M402.09,529.26c.36-2.25.82-5.27,1.22-7.51,2.25-.86,5.24-2,7.51-2.85,1.83,1.29,4.26,3,6.11,4.3-.34,2.16-.81,5-1.11,7.2-2.2,1-5.13,2.25-7.33,3.23-1.92-1.31-4.49-3-6.4-4.37"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M400.07,547.53c.21-2.36.48-5.51.73-7.87,2.21-1,5.16-2.39,7.38-3.4,1.94,1.26,4.53,3,6.49,4.18-.18,2.3-.45,5.36-.61,7.65-2.17,1.11-5.06,2.6-7.23,3.7-2-1.27-4.74-3-6.76-4.26"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M399.07,566c.09-2.36.2-5.51.31-7.87l7.3-3.67c2.05,1.21,4.78,2.83,6.85,4-.06,2.32-.15,5.42-.19,7.75-2.15,1.16-5,2.73-7.17,3.86-2.13-1.22-5-2.83-7.1-4.08"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M398.89,583.88c0-2.24,0-5.23,0-7.47,2.18-1.08,5.1-2.51,7.27-3.63,2.15,1.14,5,2.67,7.18,3.77,0,2.23.09,5.2.12,7.42-2.15,1.12-5,2.64-7.2,3.7-2.21-1.13-5.18-2.6-7.36-3.79"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M399.15,599.58c0-1.89-.07-4.41-.11-6.3,2.18-.95,5.09-2.19,7.24-3.2,2.18,1,5.09,2.26,7.3,3.16,0,1.88,0,4.4,0,6.29-2.17,1-5.06,2.28-7.27,3.17-2.16-.93-5.06-2.13-7.19-3.12"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M399.19,611.88c0-1.44,0-3.37,0-4.81,2.14-.72,5-1.64,7.12-2.43,2.15.75,5,1.79,7.19,2.46,0,1.47-.09,3.44-.15,4.91-2.16.72-5,1.73-7.22,2.36-2.09-.74-4.9-1.68-7-2.49"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M398.71,620.55c.09-1,.22-2.27.29-3.24,2.13-.45,5-1,7.09-1.53,2.09.56,4.85,1.35,7,1.83-.12,1-.25,2.37-.39,3.38-2.17.44-5.06,1.09-7.25,1.43-2-.55-4.71-1.24-6.7-1.87"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M397.43,625.52c.2-.5.5-1.15.65-1.67,2.15-.15,5-.3,7.16-.56,2,.37,4.66.91,6.67,1.19a15.86,15.86,0,0,1-.75,1.8c-2.2.17-5.13.44-7.33.49-1.93-.36-4.5-.81-6.4-1.25"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M395.73,626.94l-.43-.07-.15,0a4,4,0,0,0,1.1-.14c2.18.14,5.08.37,7.26.39,1.9.18,4.44.46,6.35.54l-1,.24c-3.94-.14-9.21-.43-13.12-.94"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M448.17,461.76c1.31.65,3.07,1.49,4.35,2.19,1.87,1.21,4.38,2.78,6.19,4.07.62.61,1.47,1.41,2.07,2-1.15-.68-2.66-1.62-3.83-2.26-1.92-1.27-4.45-3-6.43-4.2-.7-.56-1.62-1.32-2.35-1.84"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M437.73,458.46c1.35.31,3.15.68,4.48,1.06,2.06,1,4.85,2.36,6.86,3.49.78.72,1.82,1.66,2.57,2.41-1.2-.38-2.79-.92-4-1.22-2.1-1-4.89-2.49-7-3.44-.85-.69-2-1.64-2.85-2.3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M427.34,458.27c1.31-.12,3.07-.32,4.4-.34,2.22.79,5.19,1.78,7.38,2.66.92.85,2.17,2,3.07,2.84-1.2,0-2.81,0-4,.13-2.24-.76-5.21-1.82-7.48-2.47-1-.85-2.33-2-3.36-2.82"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M417.43,461.75c1.23-.6,2.85-1.46,4.13-2,2.32.48,5.43,1.08,7.72,1.66,1.09,1,2.54,2.31,3.61,3.33-1.15.51-2.7,1.13-3.81,1.74-2.32-.42-5.41-1-7.74-1.34-1.17-1-2.72-2.42-3.91-3.42"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M408.46,469.22c1.1-1.1,2.52-2.61,3.68-3.64,2.37.15,5.53.29,7.89.53l4.18,3.82c-1,1-2.43,2.25-3.4,3.29-2.35-.06-5.49-.19-7.85-.17-1.35-1.15-3.14-2.69-4.5-3.83"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M400.8,480.12c.92-1.52,2.11-3.56,3.1-5,2.38-.19,5.55-.48,7.93-.58l4.74,4.1c-.87,1.39-2.07,3.24-2.89,4.67-2.35.28-5.5.61-7.85,1-1.5-1.24-3.51-2.89-5-4.11"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M394.54,494c.74-1.87,1.7-4.38,2.5-6.22,2.35-.49,5.49-1.19,7.86-1.61l5.26,4.3c-.71,1.76-1.69,4.11-2.34,5.89-2.33.58-5.44,1.31-7.76,1.94l-5.52-4.3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M389.7,510.13c.56-2.15,1.28-5,1.89-7.14,2.32-.75,5.4-1.77,7.74-2.46l5.72,4.41c-.54,2.06-1.28,4.8-1.78,6.87-2.28.82-5.34,1.89-7.62,2.74l-5.95-4.42"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M386.2,527.93c.39-2.32.9-5.42,1.33-7.74,2.28-.93,5.3-2.19,7.58-3.09l6.15,4.47c-.38,2.26-.9,5.28-1.23,7.55-2.25,1-5.25,2.28-7.49,3.28-1.9-1.34-4.45-3.12-6.34-4.47"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M383.89,546.54c.25-2.39.57-5.59.85-8l7.44-3.45c2,1.34,4.56,3.13,6.53,4.45-.23,2.37-.55,5.53-.74,7.9L390.59,551c-2-1.34-4.7-3.11-6.7-4.46"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M382.77,565c.1-2.34.21-5.46.34-7.8l7.28-3.46c2.06,1.31,4.8,3.07,6.87,4.37-.1,2.36-.25,5.5-.33,7.87-2.19,1-5.09,2.44-7.29,3.46-2.06-1.33-4.82-3.09-6.87-4.44"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M382.69,582.41c0-2.17-.07-5.07-.07-7.24,2.09-.92,4.89-2.13,7-3.08,2.13,1.29,5,3,7.12,4.26,0,2.24,0,5.22,0,7.45-2.11.91-4.92,2.13-7.05,3-2.1-1.31-4.91-3-7-4.38"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M383.25,597.78c-.08-1.85-.18-4.33-.25-6.18,2-.72,4.74-1.64,6.75-2.41,2.14,1.21,5,2.85,7.16,4,0,1.89.09,4.4.13,6.29-2.07.67-4.82,1.6-6.92,2.2-2.06-1.16-4.84-2.68-6.87-3.9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M383.58,609.68c0-1.38-.05-3.23-.09-4.62,2-.43,4.69-1,6.68-1.48,2.08,1,4.85,2.41,7,3.36,0,1.44,0,3.36,0,4.79-2.06.4-4.8,1-6.88,1.27-2-1-4.69-2.27-6.66-3.32"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M383.34,617.84c.06-.91.16-2.11.19-3,2-.13,4.69-.25,6.68-.47,2,.84,4.69,2,6.73,2.77-.08,1-.16,2.26-.27,3.22-2.08.09-4.85.27-6.93.26-1.92-.82-4.5-1.88-6.4-2.76"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M382.3,622.28c.17-.43.43-1,.56-1.45,2,.19,4.71.49,6.74.58,1.94.67,4.5,1.6,6.46,2.19a15.53,15.53,0,0,1-.65,1.64c-2.1-.2-4.92-.42-7-.73-1.83-.66-4.29-1.5-6.1-2.23"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M381.75,623.68l-.5-.16-1-.33a3.66,3.66,0,0,0,1,0c2.05.48,4.78,1.18,6.85,1.56,1.84.5,4.28,1.21,6.14,1.62a4.55,4.55,0,0,1-1.09.12l-.31-.06c-3.35-.74-7.83-1.77-11.11-2.78"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M438.85,457.49c2.73,1.12,6.36,2.64,9,3.91l2.72,1.42.45.26c-1.33-.67-3.09-1.58-4.44-2.18-2.07-.94-4.8-2.23-6.9-3.07l-.85-.34"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M425.86,454c1.49.28,3.48.6,4.95.95,2.18.68,5.11,1.53,7.25,2.32.75.41,1.75.94,2.47,1.41-1.37-.33-3.17-.8-4.55-1-2.22-.72-5.16-1.72-7.41-2.33-.81-.4-1.87-1-2.71-1.31"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.47,454.2c1.44-.17,3.35-.44,4.8-.51,2.3.44,5.39,1,7.67,1.52.89.58,2.09,1.33,2.95,2-1.34.1-3.13.18-4.46.37-2.33-.44-5.42-1.08-7.76-1.41-1-.58-2.22-1.39-3.2-1.92"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M403.73,458.13c1.34-.66,3.09-1.6,4.47-2.16,2.38.16,5.55.31,7.91.58,1.05.76,2.45,1.76,3.47,2.55-1.26.59-3,1.33-4.19,2-2.38-.12-5.55-.35-7.94-.37-1.11-.79-2.58-1.86-3.72-2.61"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M394.07,466.16c1.17-1.19,2.71-2.82,4-3.93,2.4-.15,5.6-.41,8-.46,1.21,1,2.83,2.24,4,3.23-1.12,1.1-2.65,2.54-3.71,3.7-2.4.2-5.6.41-8,.7-1.29-1-3-2.28-4.28-3.24"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M385.86,477.8c1-1.61,2.26-3.78,3.31-5.35,2.38-.45,5.55-1.11,7.95-1.47,1.38,1.1,3.23,2.55,4.6,3.66-1,1.52-2.25,3.54-3.13,5.1-2.38.49-5.55,1.11-7.91,1.69-1.44-1.09-3.36-2.56-4.82-3.63"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M379.21,492.3c.78-1.95,1.8-4.57,2.64-6.49,2.35-.72,5.46-1.72,7.83-2.36,1.53,1.19,3.58,2.77,5.11,4-.76,1.88-1.81,4.37-2.52,6.28-2.33.74-5.45,1.71-7.76,2.52-1.59-1.18-3.7-2.75-5.3-3.92"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M374.07,509c.6-2.2,1.37-5.14,2-7.33,2.29-.93,5.33-2.19,7.65-3l5.57,4.19c-.58,2.16-1.38,5-1.91,7.19-2.28.93-5.33,2.16-7.6,3.14L374.07,509"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M370.47,527c.39-2.33.9-5.45,1.34-7.78,2.22-1.05,5.17-2.47,7.41-3.47l6,4.34c-.41,2.33-1,5.43-1.35,7.76-2.22,1-5.2,2.41-7.41,3.48-1.79-1.3-4.19-3-6-4.33"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M368.37,545.38c.22-2.35.48-5.48.73-7.83,2.09-1,4.87-2.47,7-3.5,1.89,1.33,4.4,3.12,6.31,4.44-.26,2.39-.62,5.58-.84,8l-7,3.41c-1.84-1.35-4.3-3.13-6.13-4.49"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M367.52,563.28c.06-2.25.14-5.26.23-7.52l6.57-3.19c1.94,1.36,4.51,3.19,6.46,4.54-.1,2.32-.25,5.43-.32,7.76-2,.9-4.68,2.11-6.69,3-1.88-1.37-4.39-3.18-6.25-4.58"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M367.6,579.88c0-2.06-.1-4.81-.13-6.87,1.89-.77,4.4-1.8,6.28-2.6,2,1.38,4.59,3.22,6.58,4.57,0,2.16,0,5,.08,7.19-1.93.7-4.5,1.66-6.45,2.31-1.91-1.37-4.47-3.2-6.36-4.6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M368.31,594.42c-.11-1.77-.26-4.13-.35-5.9,1.82-.52,4.27-1.19,6.09-1.75,2,1.36,4.65,3.19,6.68,4.52.08,1.84.19,4.31.27,6.15-1.9.43-4.43,1-6.35,1.38-1.9-1.31-4.47-3-6.34-4.4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M368.9,605.64c0-1.29-.13-3-.19-4.31,1.81-.2,4.23-.42,6-.69,1.95,1.22,4.54,2.86,6.53,4,0,1.37.08,3.2.1,4.57-1.9.11-4.43.3-6.33.31-1.85-1.16-4.32-2.7-6.14-3.91"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M368.89,613c0-.81.08-1.88.09-2.69,1.82.15,4.24.4,6.06.46,1.89,1.06,4.38,2.5,6.3,3.51,0,.89-.1,2.08-.18,3-1.92-.22-4.49-.47-6.39-.79-1.77-1-4.15-2.38-5.88-3.46"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M368.06,616.75a10.06,10.06,0,0,0,.46-1.14c1.84.49,4.28,1.2,6.14,1.59,1.81.92,4.2,2.17,6,3a13.08,13.08,0,0,1-.54,1.4c-2-.54-4.57-1.2-6.49-1.84-1.69-.9-4-2.07-5.6-3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M368.34,618.12l-2-1a3.31,3.31,0,0,0,.8.23c1.87.81,4.34,1.94,6.24,2.65,1.71.78,4,1.84,5.72,2.54a3.5,3.5,0,0,1-1-.06l-.63-.23c-2.78-1.17-6.5-2.72-9.19-4.09"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M415.26,452.31l5.15.55c2.59.46,6,1.05,8.61,1.63l.07,0c-1.5-.29-3.5-.72-5-.93-2.3-.35-5.36-.88-7.67-1.12l-1.15-.15"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M401.68,452.75c1.53-.2,3.58-.53,5.13-.63,2.35.06,5.49.1,7.83.28.84.25,2,.56,2.77.89-1.46.15-3.41.29-4.85.54-2.37-.09-5.54-.26-7.91-.24-.89-.27-2.06-.66-3-.84"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M390.28,457c1.41-.7,3.27-1.7,4.73-2.3,2.39-.2,5.57-.53,8-.63,1,.46,2.3,1.05,3.25,1.57-1.36.64-3.2,1.45-4.51,2.19-2.4.21-5.61.43-8,.74-1-.48-2.38-1.16-3.44-1.57"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M380.07,465.29c1.25-1.22,2.87-2.9,4.19-4,2.38-.5,5.55-1.21,7.95-1.6,1.13.68,2.66,1.58,3.76,2.31-1.21,1.18-2.86,2.72-4,4-2.39.5-5.58,1.13-8,1.73-1.18-.72-2.73-1.71-3.95-2.37"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M371.43,477.4c1-1.67,2.37-3.93,3.47-5.55,2.35-.77,5.45-1.85,7.83-2.53,1.29.88,3,2.05,4.3,3-1,1.61-2.39,3.74-3.33,5.39-2.35.76-5.48,1.74-7.8,2.59-1.34-.86-3.11-2-4.47-2.86"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M364.58,492.25c.8-2,1.82-4.65,2.68-6.61,2.27-1,5.28-2.37,7.59-3.28,1.45,1,3.38,2.34,4.82,3.36-.81,2-1.92,4.55-2.67,6.53-2.27,1-5.33,2.24-7.57,3.28-1.46-1-3.39-2.31-4.85-3.28"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M359.65,508.93c.56-2.18,1.27-5.11,1.88-7.28,2.12-1.12,4.93-2.65,7.09-3.7,1.57,1.11,3.67,2.57,5.24,3.69-.61,2.2-1.46,5.13-2,7.35-2.14,1.07-5,2.48-7.13,3.61l-5.06-3.67"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M356.43,526.59c.35-2.28.79-5.32,1.18-7.59,2-1.14,4.56-2.69,6.55-3.79l5.46,4c-.4,2.33-1,5.43-1.32,7.76-2,1.08-4.66,2.49-6.63,3.61l-5.24-4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M354.67,544.34c.17-2.25.39-5.27.59-7.52,1.82-1.08,4.25-2.53,6.09-3.58,1.68,1.28,3.93,3,5.62,4.25-.22,2.34-.52,5.46-.71,7.8-1.86,1-4.36,2.29-6.22,3.29l-5.37-4.24"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M354.07,561.34c0-2.13.07-5,.14-7.11,1.71-.91,4-2.15,5.7-3.06,1.72,1.34,4,3.12,5.76,4.44-.07,2.24-.18,5.23-.22,7.47-1.77.8-4.12,1.88-5.9,2.67-1.64-1.32-3.84-3.08-5.48-4.41"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M354.32,576.79c-.06-1.9-.15-4.45-.19-6.35,1.63-.68,3.81-1.58,5.43-2.28,1.76,1.37,4.09,3.21,5.86,4.56,0,2,.08,4.76.14,6.8-1.7.55-4,1.3-5.68,1.81-1.67-1.36-3.9-3.16-5.56-4.54"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M355.09,590c-.12-1.6-.27-3.73-.37-5.33,1.58-.37,3.69-.84,5.26-1.26,1.78,1.39,4.14,3.25,5.94,4.62.11,1.75.24,4.08.36,5.83-1.68.22-3.91.57-5.59.73-1.68-1.38-3.94-3.19-5.6-4.59"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M355.89,600.25c-.09-1.17-.19-2.73-.29-3.89,1.57,0,3.65,0,5.22-.05,1.76,1.33,4.09,3.12,5.88,4.41.06,1.27.15,3,.21,4.25-1.69-.13-3.93-.26-5.61-.49-1.63-1.26-3.81-2.93-5.41-4.23"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M356.07,606.62c0-.67,0-1.58,0-2.25,1.58.38,3.67,1,5.26,1.24,1.69,1.2,3.94,2.83,5.66,4,0,.79,0,1.85-.08,2.63-1.71-.49-4-1.1-5.68-1.7-1.55-1.16-3.64-2.69-5.17-3.9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M355.45,609.35a4.26,4.26,0,0,0,.37-.74c1.6.76,3.71,1.82,5.35,2.49,1.61,1.09,3.75,2.56,5.4,3.61a7.25,7.25,0,0,1-.45,1.08c-1.74-.84-4.09-1.91-5.78-2.84-1.47-1.08-3.45-2.48-4.89-3.6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M355.65,610.17l-1.26-1,.3.19c1.62,1.1,3.76,2.61,5.45,3.62,1.52,1,3.54,2.33,5.1,3.26l-.71-.23c-2.71-1.7-6.31-4-8.88-5.88"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M389.72,454.08l1.9-.4c3.79-.59,8.88-1.23,12.7-1.54H405c-1.55.18-3.63.37-5.17.66-2.38.3-5.57.63-7.93,1l-2.14.25"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M377.28,458.71c1.47-.73,3.41-1.76,4.92-2.39,2.37-.61,5.51-1.47,7.9-2,.9.11,2.1.21,3,.41-1.44.68-3.38,1.54-4.76,2.32-2.38.58-5.56,1.29-7.91,2-.94-.12-2.18-.34-3.13-.36"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M366.81,467.13c1.27-1.23,2.92-2.91,4.26-4.06,2.32-.88,5.4-2.12,7.76-2.89,1,.35,2.43.77,3.43,1.19-1.27,1.2-3,2.77-4.2,4.05-2.33.86-5.46,1.95-7.76,2.91-1-.37-2.42-.91-3.49-1.2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M358.26,479.23c1-1.68,2.31-3.94,3.39-5.57,2.19-1.1,5.08-2.63,7.31-3.64,1.17.59,2.75,1.36,3.9,2-1.06,1.67-2.51,3.87-3.49,5.58-2.21,1.06-5.17,2.44-7.33,3.59-1.13-.59-2.63-1.4-3.78-1.95"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M351.8,493.9c.74-1.95,1.7-4.57,2.51-6.5,2-1.25,4.64-2.95,6.69-4.11,1.27.76,3,1.77,4.23,2.55-.81,2-1.91,4.6-2.65,6.61-2,1.18-4.75,2.71-6.74,4-1.21-.76-2.81-1.78-4-2.51"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M347.29,510.16c.5-2.13,1.15-5,1.7-7.07,1.83-1.3,4.24-3.06,6.1-4.29,1.35.91,3.14,2.11,4.48,3-.57,2.18-1.35,5.08-1.86,7.27-1.86,1.21-4.36,2.78-6.18,4-1.27-.89-3-2.1-4.24-3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M344.48,527.11c.29-2.18.67-5.09,1-7.26,1.66-1.26,3.86-3,5.55-4.17l4.67,3.45c-.35,2.26-.84,5.28-1.15,7.55-1.71,1.14-4,2.64-5.69,3.82l-4.39-3.39"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M343.07,543.88c.13-2.13.29-5,.45-7.08,1.52-1.13,3.54-2.65,5.08-3.75l4.82,3.79c-.18,2.24-.43,5.22-.57,7.47-1.58,1-3.7,2.28-5.27,3.29l-4.51-3.72"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M342.75,559.64c0-2,0-4.59,0-6.55,1.41-.92,3.28-2.15,4.7-3.05l4.93,4.07c0,2.11-.1,4.92-.12,7l-5,2.5-4.58-4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M343.19,573.64c-.08-1.71-.19-4-.26-5.71l4.44-2.08c1.5,1.28,3.49,3,5,4.27.06,1.88.13,4.39.2,6.27-1.43.44-3.32,1.05-4.76,1.45-1.39-1.25-3.83-2.5-4.62-4.2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M344.05,585.27c-.12-1.39-.29-3.24-.4-4.63,1.28-.26,3-.59,4.27-.9,1.52,1.33,3.53,3.11,5.06,4.43.11,1.57.25,3.66.37,5.23-1.4.08-3.27.22-4.67.23-1.39-1.31-3.81-2.63-4.63-4.36"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M345,594c-.11-1-.25-2.32-.36-3.32,1.26.15,2.95.38,4.22.45,1.51,1.35,3.52,3.16,5.05,4.48.09,1.14.22,2.67.3,3.81-1.41-.33-3.31-.72-4.69-1.14-1.36-1.28-3.7-2.6-4.52-4.28"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M345.33,599.05c0-.51,0-1.19-.06-1.7,1.27.58,3,1.4,4.27,1.88,1.45,1.27,3.37,3,4.84,4.2,0,.65,0,1.52,0,2.17-1.44-.72-3.39-1.65-4.77-2.47-1.29-1.22-3.57-2.46-4.28-4.08"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M344.9,600.5c.1,0,.24-.11.29-.21,1.3,1,3,2.35,4.37,3.24,1.37,1.2,3.18,2.8,4.58,4a2.22,2.22,0,0,1-.36.66c-1.47-1.1-3.47-2.53-4.87-3.71-1.21-1.18-2.84-2.73-4-3.94"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M347.11,602.85l1.62,1.5c1.29,1.14,3,2.67,4.31,3.76l-.18-.13c-1.75-1.51-4.07-3.54-5.75-5.13"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M365.28,463.42l1.16-.66c3.22-1.59,7.56-3.62,10.88-5l1.29-.48,1.72-.46c-1.48.71-3.49,1.61-4.93,2.42-2.27,1-5.33,2.22-7.56,3.3a20.85,20.85,0,0,0-2.56.87"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M355.25,471.63c1.2-1.19,2.77-2.82,4.05-3.94,2.08-1.22,4.83-2.91,7-4a28.4,28.4,0,0,1,2.92-.05c-1.28,1.21-3,2.77-4.23,4.06-2.1,1.18-4.93,2.71-7,4a21.05,21.05,0,0,0-2.75,0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M347.17,483.24c.95-1.61,2.17-3.79,3.2-5.35,1.89-1.39,4.38-3.29,6.34-4.59,1,.25,2.22.55,3.14.88-1,1.66-2.42,3.85-3.36,5.55-1.91,1.32-4.5,3-6.35,4.46-.89-.29-2.06-.72-3-.95"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M341.18,497.42c.68-1.88,1.56-4.41,2.3-6.26,1.7-1.49,3.93-3.5,5.68-4.9,1,.48,2.41,1.1,3.42,1.62-.76,1.94-1.79,4.51-2.48,6.48-1.72,1.38-4.05,3.19-5.72,4.64-1-.48-2.22-1.15-3.2-1.58"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M337.16,512.93c.44-2,1-4.71,1.49-6.72,1.51-1.48,3.49-3.49,5.05-4.9,1.09.65,2.56,1.51,3.63,2.19-.5,2.11-1.21,4.91-1.66,7-1.55,1.35-3.65,3.12-5.15,4.53-1-.65-2.34-1.52-3.36-2.13"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M334.81,528.87c.24-2,.54-4.76.81-6.8,1.34-1.38,3.09-3.26,4.48-4.6,1.14.8,2.67,1.87,3.8,2.69-.3,2.15-.72,5-1,7.19-1.39,1.23-3.28,2.84-4.63,4.11-1-.78-2.43-1.83-3.48-2.59"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M333.81,544.35c.08-2,.17-4.55.28-6.49,1.19-1.21,2.76-2.84,4-4L342,537c-.13,2.1-.32,4.9-.43,7-1.26,1-3,2.35-4.21,3.4l-3.55-3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M333.83,558.59c0-1.76-.1-4.11-.11-5.87,1.08-.94,2.5-2.21,3.6-3.13l4,3.46c0,1.93,0,4.51,0,6.45-1.17.72-2.74,1.69-3.9,2.42l-3.58-3.33"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M334.51,570.86c-.1-1.48-.26-3.47-.35-5l3.32-2c1.21,1.13,2.81,2.63,4,3.74.08,1.69.17,3.93.27,5.61-1.11.37-2.58.88-3.69,1.23-1.08-1.09-2.95-2.24-3.58-3.63"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M335.52,580.61c-.14-1.15-.32-2.67-.45-3.82.95-.19,2.21-.43,3.15-.66,1.21,1.19,2.81,2.79,4,4,.12,1.35.27,3.16.4,4.52-1.08,0-2.52,0-3.6-.15-1.06-1.16-2.89-2.44-3.53-3.87"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M336.52,587.4c-.13-.75-.29-1.76-.41-2.51.92.25,2.15.63,3.09.81,1.2,1.25,2.79,2.94,4,4.17l.37,3.21c-1.09-.48-2.57-1.07-3.62-1.64-1-1.21-2.79-2.58-3.44-4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M337.07,590.78c-.05-.3-.1-.69-.15-1,.93.73,2.15,1.74,3.14,2.38,1.14,1.24,2.66,2.91,3.84,4.13,0,.48.07,1.11.07,1.59-1.12-.92-2.65-2.11-3.7-3.11-1-1.2-2.61-2.58-3.2-4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M337.76,592.09l2.49,2.88c1.07,1.22,2.49,2.85,3.59,4l-.22.14-.05,0-1.46-1.58c-2.89-3.49-2.89-3.49-4.35-5.46"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M345.64,478.62l2.74-2.82c1.85-1.6,4.28-3.78,6.19-5.29l.9-.68a18,18,0,0,1,2.24-1.21c-1.21,1.16-2.87,2.68-4,3.91-1.82,1.48-4.28,3.4-6,5a16.84,16.84,0,0,0-2,1.13"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M338.21,489.54c.86-1.51,2-3.54,2.92-5,1.59-1.66,3.68-3.91,5.35-5.49a19.25,19.25,0,0,1,2.39-.29c-1,1.58-2.28,3.67-3.16,5.3-1.61,1.58-3.79,3.65-5.33,5.3a14.22,14.22,0,0,0-2.17.18"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M332.81,502.92c.61-1.78,1.38-4.16,2.05-5.92,1.38-1.71,3.17-4,4.62-5.66.78.17,1.83.36,2.59.59-.69,1.87-1.64,4.34-2.26,6.22-1.41,1.59-3.32,3.68-4.65,5.32-.7-.17-1.63-.45-2.35-.55"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M329.38,517.43c.36-1.88.83-4.39,1.24-6.26,1.17-1.66,2.69-3.91,3.94-5.51.83.36,1.95.81,2.77,1.22-.45,2-1.07,4.65-1.46,6.66-1.22,1.5-2.88,3.48-4,5-.74-.35-1.71-.85-2.46-1.15"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M327.59,532.1c.17-1.86.37-4.35.58-6.21,1-1.53,2.27-3.59,3.32-5.06.87.52,2,1.21,2.89,1.76-.24,2-.58,4.7-.78,6.72-1.06,1.32-2.49,3.07-3.49,4.45-.75-.5-1.75-1.19-2.52-1.66"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M327.09,546.06c0-1.75,0-4.07.08-5.81.83-1.3,1.91-3,2.8-4.31.89.67,2.08,1.56,3,2.24-.08,1.92-.2,4.48-.25,6.4-.93,1.07-2.18,2.47-3.05,3.58-.76-.63-1.77-1.48-2.54-2.1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M327.53,558.52c-.09-1.53-.21-3.56-.28-5.09.71-1,1.64-2.31,2.39-3.27l3,2.65c0,1.72.07,4,.13,5.76-.82.72-1.92,1.68-2.71,2.44-.76-.75-2.07-1.53-2.51-2.49"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M328.55,568.81c-.15-1.22-.35-2.86-.48-4.09.62-.6,1.44-1.41,2.08-2l3,3c.11,1.45.25,3.38.37,4.83-.75.33-1.74.78-2.5,1.1-.73-.86-2-1.82-2.43-2.85"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M329.79,576.42c-.17-.86-.39-2-.54-2.89.57-.15,1.33-.35,1.9-.53.87,1,2,2.33,2.91,3.32.13,1.1.31,2.57.45,3.68-.71-.11-1.68-.22-2.39-.41a18.72,18.72,0,0,1-2.33-3.17"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M330.93,581c-.14-.47-.33-1.09-.46-1.56a16.67,16.67,0,0,0,1.82,1.07c.84,1.08,2,2.53,2.83,3.59.12.72.28,1.67.41,2.38a28.86,28.86,0,0,1-2.39-2,28.22,28.22,0,0,1-2.21-3.47"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M331.66,582.6l1.6,2.3c.8,1.14,1.85,2.68,2.68,3.79.05.26.12.61.16.87L334.89,588c-2.2-3.5-2.2-3.5-3.23-5.35"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M339.23,485.83c2-2.36,4.67-5.5,6.8-7.74l-1.66,1.77c-1.52,1.74-3.59,4-5,5.84l-.11.13"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M331.36,498.08c.75-1.38,1.71-3.25,2.53-4.59l.14-.21c1.25-1.84,2.88-4.33,4.22-6.12a14.18,14.18,0,0,1,1.68-1.42c-.87,1.48-2.07,3.43-2.87,5-1.3,1.8-3.07,4.19-4.27,6.06a12,12,0,0,0-1.43,1.32"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M326.74,510.42c.51-1.65,1.16-3.85,1.73-5.48,1-1.91,2.39-4.49,3.52-6.36a11.23,11.23,0,0,1,1.78-.5c-.61,1.76-1.45,4.09-2,5.86-1.07,1.78-2.54,4.13-3.53,6a7.8,7.8,0,0,0-1.5.51"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M324,523.75c.28-1.72.62-4,.94-5.72.82-1.84,1.86-4.3,2.77-6.1a15.08,15.08,0,0,1,1.9.18c-.37,1.85-.88,4.32-1.2,6.19-.87,1.65-2.07,3.84-2.85,5.54a9.08,9.08,0,0,0-1.56-.09"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M322.93,537c.09-1.67.18-3.9.3-5.57.62-1.65,1.4-3.88,2.1-5.5.59.21,1.39.48,2,.74-.17,1.84-.41,4.28-.54,6.13-.7,1.43-1.66,3.33-2.28,4.81a14.49,14.49,0,0,0-1.54-.61"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M323.06,549.19c-.06-1.51-.15-3.53-.18-5,.45-1.39,1-3.26,1.54-4.62.59.37,1.38.85,2,1.24,0,1.71-.05,4,0,5.71-.55,1.13-1.32,2.63-1.8,3.79-.44-.32-1-.78-1.48-1.08"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M324,559.67c-.16-1.26-.37-2.94-.5-4.21.31-1,.7-2.44,1.09-3.45.57.5,1.35,1.17,1.91,1.68.09,1.49.2,3.47.31,5-.44.76-1.06,1.74-1.43,2.53a7,7,0,0,1-1.38-1.51"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M325.5,567.78c-.2-.94-.48-2.19-.66-3.13.21-.62.47-1.46.75-2.06l1.83,2.09c.15,1.19.34,2.77.5,4-.35.31-.85.72-1.19,1a12.83,12.83,0,0,1-1.23-1.9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M327.15,573.21l-.13-.33c-.18-.51-.44-1.19-.61-1.71.16-.14.37-.34.54-.47.51.74,1.18,1.73,1.71,2.46.16.82.37,1.92.55,2.74a4.5,4.5,0,0,1-1.06-.57c-.3-.64-.73-1.47-1-2.12"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M329.24,577.91c-.34-.71-.78-1.66-1.1-2.38l.21.37c.46.84,1.07,2,1.56,2.81.14.42.31,1,.47,1.4l-.42-.73-.72-1.47"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M327.32,506.31c1.07-2.35,2.5-5.51,3.69-7.81l1.15-2.09-1.65,3.13c-1,2-2.3,4.68-3.17,6.73l0,0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M323,519.84l.53-2.17c.52-1.73,1.15-4.06,1.73-5.77l0-.16,1.4-3.8a11.38,11.38,0,0,1,1-1.62c-.51,1.62-1.22,3.77-1.67,5.4-.73,2-1.74,4.56-2.37,6.55a13.68,13.68,0,0,0-.7,1.57"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M321.17,531.88c.16-1.54.36-3.6.56-5.14.45-2,1-4.65,1.56-6.61a6.85,6.85,0,0,1,1-.9c-.27,1.7-.66,3.95-.88,5.65-.5,1.8-1.22,4.19-1.63,6a6.56,6.56,0,0,0-.66,1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M320.92,543.51c0-1.46-.06-3.4-.05-4.86.23-1.77.49-4.16.83-5.92a4.67,4.67,0,0,1,1-.33c-.08,1.64-.2,3.82-.25,5.46-.31,1.55-.77,3.61-1,5.17a1.9,1.9,0,0,0-.57.48"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M321.83,553.86c-.16-1.26-.38-2.94-.5-4.21,0-1.48.06-3.45.21-4.92a5,5,0,0,1,.94.17c.07,1.48.14,3.44.23,4.92-.16,1.21-.42,2.82-.47,4l-.38,0,0,0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M323.49,562.24l-.23-.9-.55-2.4c-.1-1.09-.29-2.55-.29-3.65a9.91,9.91,0,0,1,.82.63c.16,1.22.36,2.85.54,4.07a21.37,21.37,0,0,0-.07,2.65,3.11,3.11,0,0,1-.22-.4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M324.9,567c-.22-.7-.51-1.63-.72-2.33l-.21-1c.19.32.45.74.65,1,.21.9.47,2.1.69,3l.08.75L324.9,567"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-126",
    points: "326.15 570.64 326.12 570.57 326.27 570.94 326.47 571.49 326.15 570.64"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M321.32,529l.13-.76c-.15,1.51-.38,3.53-.49,5l-.33,5.35c.13-2.9.28-6.77.69-9.64"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M321,547.64c-.13-2-.27-4.61-.33-6.59l.12-1.16c0,1.43.05,3.32.12,4.75l.21,4.26-.12-1.26"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M321.73,553.93l-.4-2.76v-.55c.16,1.23.36,2.87.55,4.09l.21,1.33-.37-2.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrand);
export default __webpack_public_path__ + "static/media/logo-brand.3e1ef048821942f22512e7dbf8e8ce6a.svg";
export { ForwardRef as ReactComponent };